$.fn.pageProduct = function() {
  let self = this
  let image = self.find('.product-header__fixed-image')
  let related_products = self.find('.related-products__list')
  related_products.find('a').first().addClass('--selected');

  related_products.find('a').mouseenter(function() {
    related_products.find('a').removeClass('--selected');
    $(this).addClass('--selected')
  })

  related_products.find('a').mouseleave(function() {
    related_products.find('a').removeClass('--selected');
    related_products.find('a').first().addClass('--selected');
  })

  self.scrolled = function(top) {
    var scrollTop = $(window).scrollTop()
    var main_trigger = $('main').offset().top - scrollTop
    var image_bottom = image.offset().top - scrollTop + image.height()
    if (image_bottom > main_trigger) {
      image.addClass('pushUp')
      image.css('--offset', image_bottom - main_trigger + 'px')
    } else {
      image.removeClass('pushUp')
    }
  }

  return function() {
    $(window).ScrollEvents().add(self.scrolled)
    return self
  }()
}
